module.exports = __webpack_public_path__ + "static/img/img3.a706a540.png";